import { ButtonCollapsible } from '@bgea-js/design-library';
import { SingleDonation as SingleDonationHP } from '@bgea-js/form-templates';
import customConfirmationHPV from "../../../../src/content/climb-signup-movie/customConfirmation";
import "../../../../src/content/climb-signup-movie/climb-signup-movie.scss";
import * as React from 'react';
export default {
  ButtonCollapsible,
  SingleDonationHP,
  customConfirmationHPV,
  React
};